import { render, staticRenderFns } from "./SmallCardEvent.vue?vue&type=template&id=616e00e0&scoped=true"
import script from "./SmallCardEvent.vue?vue&type=script&lang=js"
export * from "./SmallCardEvent.vue?vue&type=script&lang=js"
import style0 from "./SmallCardEvent.vue?vue&type=style&index=0&id=616e00e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616e00e0",
  null
  
)

export default component.exports